import {
  ValidatedInput,
  ValidationMessage,
  Sidebar,
  FormLabel
} from "@/app/shared/components";
import vSelect from 'vue-select'
import categoriesDropdownlist from '@/app/drilling/components/categoriesDropdownlist.vue'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    },
    categoryId: {
      type: Number,
      default: null
    },
    categories: {
      type: Array,
      required: true
    }
  },
  components: {
    ValidatedInput,
    ValidationMessage,
    Sidebar,
    FormLabel,
    categoriesDropdownlist,
    'v-select': vSelect
  },
  watch: {
    isSidebarActive(val) {
      if (!val) return;
      if (Object.entries(this.data).length === 1) {
        this.$emit("onNewData");
      } 
      else {
        this.$emit("onEditData");
      }
    }
  },
  data() {
    return {
      model: this.createModel()
    };
  },
  computed: {
    localizedCategoryName() {
      return this.$i18n.locale.startsWith('fr') ? "nameFr" : "nameEn";
    },
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
        }
      }
    },
    category: {
      get() {
        return this.categories.find(x => x.id === this.categoryId);
      },
      set(val) {
        if (val !== null && val !== undefined)
          this.model.categoryId = val.id;
      }
    }
  },
  methods: {
    newData() {
      this.initValues();
      this.$refs.observer.reset();
    },
    editData() {
      this.model = this.data;
      this.$refs.observer.reset();
    },
    closeSidebar() {
      this.$emit("closeSidebar");
    },
    initValues() {
      if (this.data.id) return;
      this.model = this.createModel();
    },
    createModel() {
      return {
        id: 0,
        nameEn: "",
        nameFr: "",
        descriptionEn: "",
        descriptionFr: "",
        categoryId: this.categoryId,
        alternateNames: ""
      }
    },
    submitData() {
      const _this = this;
      return this.$refs.observer.validate().then((result) => {
        if (result) {
          if (_this.model.id !== null && _this.model.id > 0) {
            return this.$store.dispatch("drilling/updateTask", this.model)
              .then((response) => {
                _this.$emit("onUpdated", response.data.model);
                return response.data.model;
              })
              .finally(() => {
                _this.$vs.loading.close();
              });
          } else {
            return this.$store.dispatch("drilling/addTask", _this.model)
              .then((response) => {
                _this.$emit("onInserted", response.data.model);
                _this.model.id = response.data.model.id;
                return response.data.model;
              })
              .finally(() => {
                _this.$vs.loading.close();
              });
          }
        }
      });
    }
  }
};
